const ERROR_DOMAIN = {
  USER_DATA_EXISTS: 'User data already exists in the redux store and matches userAuthInfo. No need for sign in',
  NULL_AUTH_RESPONSE: 'NULL AUTH RESPONSE',
  GENERIC_ERROR: 'We\'re sorry, an error occurred. Please try again later.',
  GET_USER_DATA_FAILED: 'GET USER DATA FAILED',
  UNREGISTERED_VT_USER: 'unregistered-vt-user',
  UNRIGISTERED_VT_USER_NO_EMAIL: 'unregistered-vt-user-no-email',
  AUTH: {
    TOKEN_NOT_FOUND: 'token not found',
  },
  RENDER_ERROR: 'Sorry. An error occurred.',
  MODULE_NOT_FOUND: 'Module data missing. We\'re actively investigating.',
  TELEMETRY: {
    BROWSER_GEOLOCATION: 'Geolocation is not supported by this browser.',
  },
};

export default ERROR_DOMAIN;
